<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  @if (data.innerHTML) {
    <p [innerHTML]="data.message"></p>
  }
  @if (!data.innerHTML) {
    <p> {{ data.message }}</p>
  }
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" [mat-dialog-close]>{{ 'dialog.btnOk' | translate }}</button>
</div>
